import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { NOOP_VOID } from 'src/3rds/cube'

export type LiaLogoProps = Omit<SvgIconProps, 'viewBox' | 'fill'> & {
    textColor?: string
    place?: 'sign-in' | 'app-bar'
    size?: 'small' | 'medium' | 'large' | number
}

const getSizeStyles = (size?: 'small' | 'medium' | 'large' | number) => {
    if (typeof size === 'number') {
        return { width: size, height: size / 2.2 }
    }
    switch (size) {
        case 'small':
            return { width: 55, height: 25 }
        case 'large':
            return { width: 130, height: 60 }
        case 'medium':
        default:
            return { width: 90, height: 40 }
    }
}

export const LiaLogo: React.FC<LiaLogoProps> = ({ place, textColor, size = 'medium', sx, ...props }: LiaLogoProps) => {
    place && NOOP_VOID()
    const sizeStyles = getSizeStyles(size)
    
    return (
        <SvgIcon 
            viewBox="0 0 220 100" 
            fill="none" 
            sx={{ ...sizeStyles, ...sx }}
            {...props}
        >
            {/* Ícone de chat/WhatsApp estilizado */}
            <g transform="translate(10, 10)">
                {/* Balão de mensagem principal */}
                <path
                    d="M40 0C17.9 0 0 15.7 0 35c0 6.3 1.8 12.2 5 17.3L0 80l28.5-7.4c3.5 1.6 7.4 2.4 11.5 2.4 22.1 0 40-15.7 40-35S62.1 0 40 0z"
                    fill="#25D366"
                />
                {/* Símbolo de busca/lupa dentro do balão */}
                <circle cx="36" cy="32" r="12" fill="none" stroke="white" strokeWidth="4"/>
                <path d="M45 41L54 50" stroke="white" strokeWidth="4" strokeLinecap="round"/>
            </g>
            
            {/* Texto "LIA" - Tipografia elegante sans-serif */}
            <text
                x="100"
                y="62"
                fill={textColor || 'white'}
                fontSize="58"
                fontFamily="'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
                fontWeight="600"
                letterSpacing="4"
            >
                LIA
            </text>
            
            {/* Subtítulo "by Lifeshub" */}
            <text
                x="105"
                y="95"
                fill={textColor || 'white'}
                fontSize="11"
                fontFamily="Arial, sans-serif"
                opacity="0.7"
            >
                by Lifeshub
            </text>
        </SvgIcon>
    )
}

export default LiaLogo
